module.exports = __webpack_public_path__ + "img/faq-2.9a301247.jpg";